<!-- Header -->
<div class="dialog-header">
  <img src="assets/image/submit-dialog.svg" />

  <ng-container *ngIf="data.insuranceType == 'COM' && data.isVehicleOverAged">
    <div>{{ "fail.OverAgedForCOMHeader" | translate }}</div>
  </ng-container>

  <ng-container *ngIf="data.insuranceType == 'TPFT'">
    <ng-container *ngIf="data.isVehicleUnderAged">
      <div>{{ "fail.UnderAgedForTPFTHeader" | translate }}</div>
    </ng-container>

    <ng-container *ngIf="data.isVehicleOverAged">
      <div>{{ "fail.OverAgedForTPFTHeader" | translate }}</div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="data.insuranceType == 'TP'">
    <ng-container *ngIf="data.isVehicleUnderAged">
      <div>{{ "fail.UnderAgedForTPHeader" | translate }}</div>
    </ng-container>

    <ng-container *ngIf="data.isVehicleOverAged">
      <div>{{ "fail.OverAgedForTPHeader" | translate }}</div>
    </ng-container>
  </ng-container>
</div>

<!-- Content -->
<div class="dialog-content">

  <!-- TODO: E-Hailing Version? -->

  <ng-container *ngIf="data.insuranceType == 'COM' && data.isVehicleOverAged">
    <div [innerHTML]="'fail.OverAgedForCOMLine1' | translate"></div>
    <div [innerHTML]="'fail.OverAgedForCOMLine2' | translate"></div>
  </ng-container>

  <ng-container *ngIf="data.insuranceType == 'TPFT'">
    <ng-container *ngIf="data.isVehicleUnderAged">
    <div [innerHTML]="'fail.UnderAgedForTPFTLine1' | translate"></div>
    <div [innerHTML]="'fail.UnderAgedForTPFTLine2' | translate"></div>
    </ng-container>

    <ng-container *ngIf="data.isVehicleOverAged">
    <div [innerHTML]="'fail.OverAgedForTPFTLine1' | translate"></div>
    <div [innerHTML]="'fail.OverAgedForTPFTLine2' | translate"></div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="data.insuranceType == 'TP'">
    <ng-container *ngIf="data.isVehicleUnderAged">
    <div [innerHTML]="'fail.UnderAgedForTPLine1' | translate"></div>
    <div [innerHTML]="'fail.UnderAgedForTPLine2' | translate"></div>
    </ng-container>

    <ng-container *ngIf="data.isVehicleOverAged">
    <div [innerHTML]="'fail.OverAgedForTPLine1' | translate"></div>
    <div [innerHTML]="'fail.OverAgedForTPLine2' | translate"></div>
    </ng-container>
  </ng-container>

  <div>{{ "common.thankyou" | translate }}.</div>
</div>

<!-- Footer -->
<div class="dialog-footer">
  <!-- Close Button -->
  <button
    class="btn"
    mat-stroked-button
    (click)="onBackToHome()"
  >
    {{ "success.close" | translate }}
  </button>
</div>

<!--
<div>
    <div class="fail-graphic">
        <img src="assets/image/submit-dialog.svg" alt="" />
        <div>
            {{ "fail.requestFailed" | translate }}
        </div>
    </div>

    <div class="fail-content">
        <ng-container *ngIf="!data.isWithEHailing">
            <div class="fail-content__paragraph">
                {{ "fail.vehicleAgeLimit" | translate }} <span class="fail-content__paragraph--red">{{ "fail.unavailable" | translate }} </span> <span [innerHTML]="'fail.vehicleAgeLimit2' | translate : { numOfYears: 20 }"></span>
            </div>

            <div class="fail-content__paragraph" [innerHTML]="'fail.vehicleAgeLimit3' | translate"></div>

            <div class="fail-content__paragraph">
                {{ "common.thankyou" | translate }}.
            </div>
        </ng-container>

        <ng-container *ngIf="data.isWithEHailing">
            <div class="fail-content__paragraph">
                {{ "fail.vehicleAgeLimitWithEHailing" | translate }} <span class="fail-content__paragraph--red">{{ "fail.unavailable" | translate }} </span> <span [innerHTML]="'fail.vehicleAgeLimit2' | translate : { numOfYears: 15 }"></span>
            </div>
        </ng-container>

        <div class="fail-content__btn-container">
            <button *ngIf="!data.isWithEHailing" class="fail-content__btn fail-content__btn--fill" mat-flat-button (click)="onBackToHome()">
                {{ "fail.requestQuote" | translate }}
            </button>
            <button class="fail-content__btn" mat-stroked-button mat-dialog-close>
                {{ "success.close" | translate }}
            </button>
        </div>
    </div>
</div>
-->